import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./UsersList.css";
import useAxios from "./useAxios";
import useSessionStorage from "./useSessionStorage";
import ConfirmDialog from "./ConfirmDialog";

const UsersList = ({ logout }) => {
  const navigate = useNavigate();
  const [axios] = useAxios(true, logout);
  const [tenant] = useSessionStorage("tenant");

  const [users, setUsers] = useState([]);
  const [deleteUser, setDeleteUser] = useState(null);

  useEffect(() => {
    axios.get("users", setUsers);
  }, []);

  const handleDeleteClick = (user) => {
    setDeleteUser(user);
  };

  const handleDeleteConfirm = () => {
    if (deleteUser) {
      axios.delete(`/user/${deleteUser.id}`, () => {
        setUsers(users.filter(u => u.id !== deleteUser.id));
        setDeleteUser(null);
      });
    }
  };

  const handleDeleteCancel = () => {
    setDeleteUser(null);
  };

  return (
    <div className="users-list">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          marginBottom: 24,
        }}
      >
        <h2 style={{ margin: 0 }}>Users</h2>
        <button
          className="edit-button"
          aria-label="Add New User"
          style={{
            fontSize: 24,
            padding: "4px 14px",
            margin: 0,
            lineHeight: 1,
          }}
          onClick={() => navigate("/configuration/user/new")}
        >
          +
        </button>
      </div>
      <table className="users-list">
        <thead>
          <tr>
            {tenant.super ? <th>Tenant</th> : null}
            <th>Name</th>
            <th>Username</th>
            <th>Email</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id}>
              {tenant.super ? <td>{user.tenant?.name}</td> : null}
              <td>{user.name}</td>
              <td>{user.username}</td>
              <td>{user.email}</td>
              <td>
                <button
                  className="edit-button"
                  onClick={() => navigate("/configuration/user/" + user.id)}
                  style={{ marginRight: "8px" }}
                >
                  Edit
                </button>
                {tenant.super && (
                  <button
                    className="delete-button"
                    onClick={() => handleDeleteClick(user)}
                    style={{
                      backgroundColor: "#dc3545",
                      color: "white",
                      border: "1px solid #dc3545",
                      padding: "4px 8px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Delete
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <ConfirmDialog
        isOpen={!!deleteUser}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        variant="danger"
        title="⚠️ GDPR Data Deletion Warning"
        message={
          deleteUser
            ? `You are about to permanently delete all data for user: ${deleteUser.name} (${deleteUser.email}). THIS ACTION CANNOT BE UNDONE.`
            : ""
        }
        details={[
          "User profile and personal information",
          "Account credentials and authentication data",
          "All associated user claims and permissions",
          "Any other user-related data in the system"
        ]}
        confirmText="Yes, Permanently Delete User Data"
        cancelText="Cancel"
      />
    </div>
  );
};

export default UsersList;
